import type { ManagedAgent, ProjectId } from "@taskin-code/contracts";
import { DEFAULT_PROVIDER_INTERACTION_MODE, DEFAULT_RUNTIME_MODE } from "@taskin-code/contracts";
import { buildAgentModelSelection } from "@taskin-code/shared/managedAgentModelOptions";
import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { newCommandId, newThreadId } from "~/lib/utils";
import { readNativeApi } from "~/nativeApi";
import { useTerminalStateStore } from "~/terminalStateStore";
import { openThreadAndDispatchCreate } from "./openThreadAndDispatchCreate";

export function useCreateInitiativeThread(projectId: ProjectId) {
  const navigate = useNavigate();
  const openChatThreadPage = useTerminalStateStore((state) => state.openChatThreadPage);
  return useCallback(
    async (agent: ManagedAgent) => {
      const api = readNativeApi();
      if (!api) throw new Error("Not connected to the server.");
      const threadId = newThreadId();
      const prepared = await api.workspace.prepareThreadWorktree({
        projectId,
        threadId,
        branchName: `iniciativa-${threadId.slice(0, 8)}`,
      });
      await openThreadAndDispatchCreate({
        threadId,
        navigate,
        openChatThreadPage,
        dispatch: api.orchestration.dispatchCommand,
        command: {
          type: "thread.create",
          commandId: newCommandId(),
          threadId,
          projectId,
          title: `Iniciativa · ${agent.name}`,
          modelSelection: buildAgentModelSelection(agent),
          runtimeMode: DEFAULT_RUNTIME_MODE,
          interactionMode: DEFAULT_PROVIDER_INTERACTION_MODE,
          kind: "initiative",
          envMode: "worktree",
          branch: prepared.branch,
          worktreePath: prepared.worktreePath,
          environmentId: null,
          createdAt: new Date().toISOString(),
        },
      });
    },
    [navigate, openChatThreadPage, projectId],
  );
}
